import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CustomerForm from '../components/CustomerForm';
import EditCustomerForm from '../components/EditCustomerForm';
import '../styles/CustomerForm.css';
import '../styles/Customers.css';

const SellerCustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          navigate('/login');
          return;
        }
        
        const response = await axios.get('/api/customers/seller', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        setCustomers(response.data);
      } catch (error) {
        console.error('Error fetching customers:', error);
        setError('No se pudieron cargar los clientes. Por favor, inténtelo de nuevo.');
        
        // If unauthorized, redirect to login
        if (error.response && error.response.status === 401) {
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, [navigate, refreshData]);

  const handleCustomerAdded = () => {
    // Refresh the customers list
    setRefreshData(!refreshData);
    // Hide the form
    setShowForm(false);
    // Show success message
    setSuccessMessage('Cliente agregado exitosamente');
    
    // Hide message after 3 seconds
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };

  const handleEditClick = (customer) => {
    setEditingCustomer(customer);
    setShowEditForm(true);
    setShowForm(false); // Cerrar el formulario de agregar si está abierto
  };

  const handleCustomerUpdated = () => {
    // Refresh the customers list
    setRefreshData(!refreshData);
    // Hide the edit form
    setShowEditForm(false);
    setEditingCustomer(null);
    // Show success message
    setSuccessMessage('Cliente actualizado exitosamente');
    
    // Hide message after 3 seconds
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };

  if (loading && customers.length === 0) {
    return <div className="loading">Cargando clientes...</div>;
  }

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Gestión de Clientes</h1>
        <button onClick={() => navigate('/seller-dashboard')} className="back-btn">
          Volver al Dashboard
        </button>
      </header>

      <div className="customers-section">
        <div className="customers-section-header">
          <h2>Clientes Registrados</h2>
          <button 
            className="add-customer-btn"
            onClick={() => setShowForm(true)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Agregar Cliente
          </button>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {successMessage && (
          <div className="success-message">
            {successMessage}
          </div>
        )}

        {showForm ? (
          <CustomerForm 
            onCustomerAdded={handleCustomerAdded} 
            onCancel={() => setShowForm(false)} 
            isSeller={true}
          />
        ) : null}

        {showEditForm && editingCustomer ? (
          <EditCustomerForm 
            customer={editingCustomer}
            onCustomerUpdated={handleCustomerUpdated}
            onCancel={() => {
              setShowEditForm(false);
              setEditingCustomer(null);
            }}
            isSeller={true}
          />
        ) : null}

        <div className="customers-list">
          {customers.length === 0 ? (
            <p className="no-customers">No hay clientes registrados. 
              <button onClick={() => setShowForm(true)}>Agregar Cliente</button>
            </p>
          ) : (
            <table className="customers-table">
              <thead>
                <tr>
                  <th>Nombre/Razón Social</th>
                  <th>RFC</th>
                  <th>Régimen Fiscal</th>
                  <th>Email</th>
                  <th>Teléfono</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {customers.map(customer => (
                  <tr key={customer.id}>
                    <td>{customer.cus_name}</td>
                    <td>{customer.cus_rfc || 'N/A'}</td>
                    <td>{customer.regimenfiscal ? customer.regimenfiscal.rf_nombreregimen : 'N/A'}</td>
                    <td>{customer.cus_email || 'N/A'}</td>
                    <td>{customer.cus_phone || 'N/A'}</td>
                    <td>
                      <span className={`status active`}>
                        Activo
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button 
                          className="edit-btn"
                          onClick={() => handleEditClick(customer)}
                        >
                          Editar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default SellerCustomersPage;
